import { cva, type VariantProps } from 'class-variance-authority';

/**
 * HEN Drawer Content variants using HEN Design System tokens.
 * All styling references design tokens defined in tailwind.config.ts.
 */
export const drawerContentVariants = cva('', {
  variants: {
    size: {
      full: [
        'data-[vaul-drawer-direction=top]:max-h-[100vh] data-[vaul-drawer-direction=top]:h-full',
        'data-[vaul-drawer-direction=bottom]:max-h-[100vh] data-[vaul-drawer-direction=bottom]:h-full',
        'data-[vaul-drawer-direction=right]:max-w-[100vw] data-[vaul-drawer-direction=right]:w-full ',
        'data-[vaul-drawer-direction=left]:max-w-[100vw] data-[vaul-drawer-direction=left]:w-full',
      ],
      '3/4': [
        'data-[vaul-drawer-direction=top]:max-h-[75vh] data-[vaul-drawer-direction=top]:h-3/4',
        'data-[vaul-drawer-direction=bottom]:max-h-[75vh] data-[vaul-drawer-direction=bottom]:h-3/4',
        'data-[vaul-drawer-direction=right]:max-w-[75vw] data-[vaul-drawer-direction=right]:w-3/4',
        'data-[vaul-drawer-direction=left]:max-w-[75vw] data-[vaul-drawer-direction=left]:w-3/4',
      ],
      '1/2': [
        'data-[vaul-drawer-direction=top]:max-h-[50vh] data-[vaul-drawer-direction=top]:h-1/2',
        'data-[vaul-drawer-direction=bottom]:max-h-[50vh] data-[vaul-drawer-direction=bottom]:h-1/2',
        'data-[vaul-drawer-direction=right]:max-w-[50vw] data-[vaul-drawer-direction=right]:w-1/2',
        'data-[vaul-drawer-direction=left]:max-w-[50vw] data-[vaul-drawer-direction=left]:w-1/2',
      ],
      '1/3': [
        'data-[vaul-drawer-direction=top]:max-h-[33vh] data-[vaul-drawer-direction=top]:h-1/3',
        'data-[vaul-drawer-direction=bottom]:max-h-[33vh] data-[vaul-drawer-direction=bottom]:h-1/3',
        'data-[vaul-drawer-direction=right]:max-w-[33vw] data-[vaul-drawer-direction=right]:w-1/3',
        'data-[vaul-drawer-direction=left]:max-w-[33vw] data-[vaul-drawer-direction=left]:w-1/3',
      ],
      '1/4': [
        'data-[vaul-drawer-direction=top]:max-h-[25vh] data-[vaul-drawer-direction=top]:h-1/4',
        'data-[vaul-drawer-direction=bottom]:max-h-[25vh] data-[vaul-drawer-direction=bottom]:h-1/4',
        'data-[vaul-drawer-direction=right]:max-w-[25vw] data-[vaul-drawer-direction=right]:w-1/4',
        'data-[vaul-drawer-direction=left]:max-w-[25vw] data-[vaul-drawer-direction=left]:w-1/4',
      ],
      auto: [
        'data-[vaul-drawer-direction=top]:max-h-[100vh] data-[vaul-drawer-direction=top]:h-auto',
        'data-[vaul-drawer-direction=bottom]:max-h-[100vh] data-[vaul-drawer-direction=bottom]:h-auto',
        'data-[vaul-drawer-direction=right]:max-w-[100vw] data-[vaul-drawer-direction=right]:w-auto',
        'data-[vaul-drawer-direction=left]:max-w-[100vw] data-[vaul-drawer-direction=left]:w-auto',
      ],
    },
  },
  defaultVariants: {
    size: 'auto',
  },
});

export type DrawerContentVariantProps = VariantProps<
  typeof drawerContentVariants
>;
